import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "itemReceiptNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.ITEM_RECEIPT.fullString,
    hasInputLabel: true,
  },
  {
    apiName: "defaultSyncItemReceipts",
    component: "FrmRadioGroup",
    options: [
      { value: "None", label: i18n("settings.itemReceiptSyncOptions.None") },
      { value: "Bill", label: i18n("settings.itemReceiptSyncOptions.Bill") },
      {
        value: "CashPurchase",
        label: i18n("settings.itemReceiptSyncOptions.Cash"),
      },
      { value: "Check", label: i18n("settings.itemReceiptSyncOptions.Check") },
      {
        value: "CreditCardCharge",
        label: i18n("settings.itemReceiptSyncOptions.CreditCard"),
      },
    ],
  },
];
